import { Component } from '@angular/core';

import { RouteType } from '@ridango/components';

@Component({
    selector: 'gl-schedule-routes-page',
    templateUrl: './schedule-routes-page.component.html',
    styleUrls: ['./schedule-routes-page.component.scss']
})
export class ScheduleRoutesPageComponent {
    availableTypes = [RouteType.BUS];
}
